import { __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { inject, injectable } from 'tsyringe';
import { fetchGet, fetchPost } from '@gn-audio/core';
import { compareLocales, getBasketFromStorage, getDefaultHeaders, getDefaultRequestInit, removeBasketFromStorage, saveBasketToStorage } from '../utilities';
import { SFCCTokenService } from './sfcc-token.service';
var SFCCBasketService = /** @class */ (function () {
    function SFCCBasketService(tokenService, storage, settings) {
        this.tokenService = tokenService;
        this.storage = storage;
        this.settings = settings;
        this.normalizeLocale = function (locale) {
            return locale.replace('-', '_');
        };
    }
    SFCCBasketService.prototype.addProducts = function (skus, services, engravingMessage) {
        return __awaiter(this, void 0, void 0, function () {
            var body, requestPath, productItem;
            return __generator(this, function (_a) {
                body = skus.map(function (x) { return ({ product_id: x, quantity: 1 }); });
                requestPath = '/items';
                productItem = body[0];
                if (!!(services === null || services === void 0 ? void 0 : services.length)) {
                    productItem.c_services = services.map(function (service) { return ({
                        serviceProductId: service.sku,
                        value: service.value,
                    }); });
                }
                if (!!engravingMessage) {
                    productItem.c_engravingMsg = engravingMessage;
                }
                return [2 /*return*/, this.makeRequest("POST" /* HttpRequestMethod.Post */, requestPath, body)];
            });
        });
    };
    SFCCBasketService.prototype.addProductsAsBasketItems = function (items) {
        return __awaiter(this, void 0, void 0, function () {
            var products;
            return __generator(this, function (_a) {
                products = items.map(function (_a) {
                    var sku = _a.sku, engravingMessage = _a.engravingMessage, services = _a.services, quantity = _a.quantity;
                    var product = {
                        product_id: sku,
                        quantity: quantity,
                    };
                    if (!!engravingMessage) {
                        product.c_engravingMsg = engravingMessage;
                    }
                    if (!!(services === null || services === void 0 ? void 0 : services.length)) {
                        product.c_services = services.map(function (service) { return ({
                            serviceProductId: service.sku,
                            value: service.value
                        }); });
                    }
                    return product;
                });
                return [2 /*return*/, this.makeRequest("POST" /* HttpRequestMethod.Post */, '/items', products)];
            });
        });
    };
    SFCCBasketService.prototype.createSharedBasket = function (basket) {
        return __awaiter(this, void 0, void 0, function () {
            var requestUrl, headers, requestInit, sharedBasket, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestUrl = "".concat(this.sfccBaseUrl, "/SharedBasket-Create");
                        return [4 /*yield*/, getDefaultHeaders(this.tokenService.ensure(), this.clientId)];
                    case 1:
                        headers = _a.sent();
                        requestInit = getDefaultRequestInit("POST" /* HttpRequestMethod.Post */, null, headers);
                        sharedBasket = {
                            product_items: basket.product_items,
                            coupon_items: basket.coupon_items,
                        };
                        return [4 /*yield*/, fetchPost(requestUrl, sharedBasket, requestInit)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response.customObjectKey];
                }
            });
        });
    };
    SFCCBasketService.prototype.getBasketByCustomObjectKey = function (basketCustomObjectKey) {
        return __awaiter(this, void 0, void 0, function () {
            var requestUrl, headers, requestInit, response, restoredBasket;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestUrl = "".concat(this.settings.shopApiBaseUrl, "/custom_objects/SharedBasket/").concat(basketCustomObjectKey);
                        return [4 /*yield*/, getDefaultHeaders(this.tokenService.ensure(), this.clientId)];
                    case 1:
                        headers = _a.sent();
                        requestInit = getDefaultRequestInit("GET" /* HttpRequestMethod.Get */, null, headers);
                        return [4 /*yield*/, fetchGet(requestUrl, requestInit)];
                    case 2:
                        response = _a.sent();
                        restoredBasket = JSON.parse(response.c_basket);
                        return [2 /*return*/, restoredBasket];
                }
            });
        });
    };
    SFCCBasketService.prototype.createBasketFromOtherBasket = function (basketToTransfer) {
        return __awaiter(this, void 0, void 0, function () {
            var baseUrl, finalUrl, headers, requestInit;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        baseUrl = "".concat(this.settings.shopApiBaseUrl, "/baskets");
                        finalUrl = this.addLocaleToUrl(baseUrl);
                        return [4 /*yield*/, getDefaultHeaders(this.tokenService.ensure(), this.clientId)];
                    case 1:
                        headers = _a.sent();
                        requestInit = getDefaultRequestInit("POST" /* HttpRequestMethod.Post */, null, headers);
                        return [2 /*return*/, fetchPost(finalUrl, basketToTransfer, requestInit)];
                }
            });
        });
    };
    SFCCBasketService.prototype.createBasket = function (products) {
        if (products === void 0) { products = []; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.makeRequest("POST" /* HttpRequestMethod.Post */, 'items', products)];
            });
        });
    };
    SFCCBasketService.prototype.applyCoupon = function (couponCode) {
        return __awaiter(this, void 0, void 0, function () {
            var body;
            return __generator(this, function (_a) {
                body = { code: couponCode };
                return [2 /*return*/, this.makeRequest("POST" /* HttpRequestMethod.Post */, 'coupons', body)];
            });
        });
    };
    SFCCBasketService.prototype.removeBasket = function (basketId) {
        return __awaiter(this, void 0, void 0, function () {
            var headers, requestInit;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getDefaultHeaders(this.tokenService.ensure(), this.clientId)];
                    case 1:
                        headers = _a.sent();
                        requestInit = getDefaultRequestInit("DELETE" /* HttpRequestMethod.Delete */, null, headers);
                        return [4 /*yield*/, fetch("".concat(this.baseUrl, "/baskets/").concat(basketId), requestInit)];
                    case 2:
                        _a.sent();
                        this.storage.removeItem("basket-id" /* StorageKey.BasketId */);
                        return [2 /*return*/];
                }
            });
        });
    };
    SFCCBasketService.prototype.removeProduct = function (itemId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.makeRequest("DELETE" /* HttpRequestMethod.Delete */, "items/".concat(itemId))];
            });
        });
    };
    SFCCBasketService.prototype.removeCoupon = function (couponItemId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.makeRequest("DELETE" /* HttpRequestMethod.Delete */, "coupons/".concat(couponItemId))];
            });
        });
    };
    SFCCBasketService.prototype.setQuantity = function (itemId, sku, quantity) {
        return __awaiter(this, void 0, void 0, function () {
            var body;
            return __generator(this, function (_a) {
                body = { product_id: sku, quantity: quantity };
                return [2 /*return*/, this.makeRequest("PATCH" /* HttpRequestMethod.Patch */, "items/".concat(itemId), body)];
            });
        });
    };
    SFCCBasketService.prototype.setServiceValue = function (itemId, quantity, serviceSku, serviceValue, engravingMessage) {
        return __awaiter(this, void 0, void 0, function () {
            var productItem, serviceObject, requestPath;
            return __generator(this, function (_a) {
                productItem = {
                    quantity: quantity,
                    c_productLineItemID: itemId,
                };
                productItem.c_services = [];
                if (serviceSku && serviceValue) {
                    serviceObject = {
                        serviceProductId: serviceSku,
                        value: serviceValue
                    };
                    productItem.c_services.push(serviceObject);
                }
                if (engravingMessage != null) {
                    productItem.c_engravingMsg = engravingMessage;
                }
                requestPath = '/items';
                requestPath += "/".concat(itemId);
                return [2 /*return*/, this.makeRequest("PATCH" /* HttpRequestMethod.Patch */, requestPath, productItem)];
            });
        });
    };
    SFCCBasketService.prototype.getBasket = function (basketId) {
        return __awaiter(this, void 0, void 0, function () {
            var token, headers, requestInit, requestUrl, basketResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!basketId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.ensureBasket()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, this.tokenService.ensure()];
                    case 3:
                        token = _a.sent();
                        return [4 /*yield*/, getDefaultHeaders(token, this.clientId)];
                    case 4:
                        headers = _a.sent();
                        requestInit = getDefaultRequestInit("GET" /* HttpRequestMethod.Get */, null, headers);
                        requestUrl = this.addLocaleToUrl("".concat(this.baseUrl, "/baskets/").concat(basketId));
                        return [4 /*yield*/, fetch(requestUrl, requestInit)];
                    case 5:
                        basketResponse = _a.sent();
                        return [4 /*yield*/, basketResponse.json()];
                    case 6: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Ensures that basket is created for the user.
     * @remarks Currency must not used on basket creation
     */
    SFCCBasketService.prototype.ensureBasket = function () {
        return __awaiter(this, void 0, void 0, function () {
            var token, guestToken, isAuthorized, basketToTransfer, basketId, isBasketIdAvailable, headers, method, requestInit, baseRequestUrl, requestUrl, basketResponse, basket, basketException, type, customerBasketId, customerBasket;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tokenService.ensure()];
                    case 1:
                        token = _a.sent();
                        guestToken = localStorage.getItem("web-store-guest-token" /* webStoreApiEnums.StorageKey.WebStoreGuestToken */);
                        isAuthorized = this.tokenService.isAuthorized;
                        basketToTransfer = null;
                        if (isAuthorized) {
                            basketToTransfer = getBasketFromStorage(this.storage, guestToken);
                            removeBasketFromStorage(this.storage, guestToken);
                        }
                        basketId = basketToTransfer ? '' : this.storage.getItem("basket-id" /* StorageKey.BasketId */);
                        isBasketIdAvailable = !!basketId;
                        if (!isBasketIdAvailable && basketToTransfer) {
                            delete basketToTransfer.currency;
                        }
                        return [4 /*yield*/, getDefaultHeaders(token, this.clientId)];
                    case 2:
                        headers = _a.sent();
                        method = isBasketIdAvailable ? "GET" /* HttpRequestMethod.Get */ : "POST" /* HttpRequestMethod.Post */;
                        requestInit = getDefaultRequestInit(method, basketToTransfer, headers);
                        baseRequestUrl = "".concat(this.baseUrl, "/baskets");
                        requestUrl = isBasketIdAvailable ? "".concat(baseRequestUrl, "/").concat(basketId) : baseRequestUrl;
                        return [4 /*yield*/, fetch(this.addLocaleToUrl(requestUrl), requestInit)];
                    case 3:
                        basketResponse = _a.sent();
                        if (!basketResponse.ok) return [3 /*break*/, 5];
                        return [4 /*yield*/, basketResponse.json()];
                    case 4:
                        basket = _a.sent();
                        this.storage.setItem("basket-id" /* StorageKey.BasketId */, basket.basket_id);
                        return [2 /*return*/, basket];
                    case 5: return [4 /*yield*/, basketResponse.json()];
                    case 6:
                        basketException = _a.sent();
                        type = basketException.fault.type;
                        if (!(type === "BasketNotFoundException" /* BasketExceptionType.BasketNotFoundException */ || type === "InvalidCustomerException" /* BasketExceptionType.InvalidCustomerException */)) return [3 /*break*/, 8];
                        this.storage.removeItem("basket-id" /* StorageKey.BasketId */);
                        return [4 /*yield*/, this.ensureBasket()];
                    case 7: return [2 /*return*/, _a.sent()];
                    case 8:
                        if (!(type === "CustomerBasketsQuotaExceededException" /* BasketExceptionType.CustomerBasketsQuotaExceededException */)) return [3 /*break*/, 18];
                        customerBasketId = basketException.fault.arguments.basketIds;
                        if (!isAuthorized) return [3 /*break*/, 15];
                        if (!basketToTransfer) return [3 /*break*/, 10];
                        // If there are guest basket that should be transfered and authorized basket
                        // we should delete authorized one and try to transfer guest one
                        saveBasketToStorage(this.storage, guestToken, basketToTransfer);
                        return [4 /*yield*/, this.deleteBasket(customerBasketId)];
                    case 9:
                        _a.sent();
                        return [3 /*break*/, 14];
                    case 10: return [4 /*yield*/, this.getBasket(customerBasketId)];
                    case 11:
                        customerBasket = _a.sent();
                        if (!compareLocales(this.settings.shopApiLocale, customerBasket.c_localeID)) return [3 /*break*/, 12];
                        this.storage.setItem("basket-id" /* StorageKey.BasketId */, customerBasketId);
                        return [3 /*break*/, 14];
                    case 12: return [4 /*yield*/, this.deleteBasket(customerBasketId)];
                    case 13:
                        _a.sent();
                        _a.label = 14;
                    case 14: return [3 /*break*/, 16];
                    case 15:
                        // We should use existing guest basket received in exception
                        this.storage.setItem("basket-id" /* StorageKey.BasketId */, customerBasketId);
                        _a.label = 16;
                    case 16: return [4 /*yield*/, this.ensureBasket()];
                    case 17: return [2 /*return*/, _a.sent()];
                    case 18: 
                    // Any other exceptions should be thrown
                    return [2 /*return*/, Promise.reject(basketException)];
                }
            });
        });
    };
    SFCCBasketService.prototype.deleteBasket = function (basketId) {
        return __awaiter(this, void 0, void 0, function () {
            var headers, requestInit, requestUrl, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getDefaultHeaders(this.tokenService.ensure(), this.clientId)];
                    case 1:
                        headers = _a.sent();
                        requestInit = getDefaultRequestInit("DELETE" /* HttpRequestMethod.Delete */, null, headers);
                        requestUrl = this.addLocaleToUrl("".concat(this.baseUrl, "/baskets/").concat(basketId));
                        return [4 /*yield*/, fetch(requestUrl, requestInit)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response.ok ? Promise.resolve() : Promise.reject()];
                }
            });
        });
    };
    SFCCBasketService.prototype.makeRequest = function (method, requestPath, body) {
        if (body === void 0) { body = null; }
        return __awaiter(this, void 0, void 0, function () {
            var basket_id, headers, requestInit, requestUrl, response, json;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.ensureBasket()];
                    case 1:
                        basket_id = (_a.sent()).basket_id;
                        return [4 /*yield*/, getDefaultHeaders(this.tokenService.ensure(), this.clientId)];
                    case 2:
                        headers = _a.sent();
                        requestInit = getDefaultRequestInit(method, body, headers);
                        requestUrl = this.addLocaleToUrl("".concat(this.baseUrl, "/baskets/").concat(basket_id, "/").concat(requestPath));
                        return [4 /*yield*/, fetch(requestUrl, requestInit)];
                    case 3:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 4:
                        json = _a.sent();
                        return [2 /*return*/, response.ok ? json : Promise.reject(json)];
                }
            });
        });
    };
    SFCCBasketService.prototype.addLocaleToUrl = function (path) {
        var delimiter = path.indexOf('?') > -1 ? '&' : '?';
        return "".concat(path).concat(delimiter, "locale=").concat(this.settings.shopApiLocale);
    };
    Object.defineProperty(SFCCBasketService.prototype, "clientId", {
        get: function () {
            return this.settings.shopApiClientId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SFCCBasketService.prototype, "baseUrl", {
        get: function () {
            return this.settings.shopApiBaseUrl;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SFCCBasketService.prototype, "sfccBaseUrl", {
        get: function () {
            return "".concat(this.settings.sfccBaseUrl, "/").concat(this.normalizeLocale(this.settings.shopApiLocale || ''));
        },
        enumerable: false,
        configurable: true
    });
    SFCCBasketService = __decorate([
        injectable(),
        __param(1, inject("basketStorage" /* DiToken.Storage */)),
        __param(2, inject("basketSettings" /* DiToken.Settings */)),
        __metadata("design:paramtypes", [SFCCTokenService,
            Storage, Object])
    ], SFCCBasketService);
    return SFCCBasketService;
}());
export { SFCCBasketService };
